import React, { useState, useEffect, useCallback, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { useQuery, useMutation, useManualQuery, ClientContext } from "graphql-hooks";
import {
  Container,
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Tooltip,
  Button,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import styled from "styled-components";
//import { styled } from '@mui/material/styles';
import { Link, useNavigate } from "react-router-dom";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import update from "immutability-helper";

import { PeriodComponents, GetTemplateEvents } from "./TermTemplateComponents.js";
import { ComponentDragBox } from "./ComponentDragBox.js";
import { PeriodDropBox } from "./PeriodDropBox.js";
import { EventDropBox } from "./EventDropBox.js";
import EditPeriodDialog from "./EditPeriodDialog.js";
import EditEventDialog from "./EditEventDialog.js";
// import TemplateHeader from "./TemplateHeader.js";
import backImg from "../../assets/icons/back.png";
import TemplateInfoInputDialog from "./TemplateInfoInputDialog.js";
import AlertDialog from "../../components/AlertDialog.js";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";

import {
  GET_TERM_TEMPLATE_DATA_BY_ID,
  EDIT_TERM_TEMPLATE_NAME_MUTATION,
  GET_TERM_TEMPLATE_DATA_BY_UUID,
} from "../../graphQL/term_template_qry";
import {
  TEMPLATE_ALL_PERIODS_QUERY,
  TEMPLATE_ADD_PERIOD_MUTATION,
  TEMPLATE_UPDATE_PERIOD_MUTATION,
  TEMPLATE_DELETE_PERIOD_MUTATION,
} from "../../graphQL/template_period_qry";
import {
  ADD_TEMPLATE_EVENT_MUTATION,
  UPDATE_TEMPLATE_EVENT_MUTATION,
  DELETE_TEMPLATE_EVENT_MUTATION,
} from "../../graphQL/template_event_qry";

import { project_url } from "../../constants/Data";

import Header from "./Header.js";

var findAnd = require("find-and");

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -40px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  cardContainer: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: "7rem",
    minWidth: "1400px",
  },
  container: {
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    // height: "936px",
    borderRadius: "8px",
  },

  ComponentDragBox: {
    float: "left",
  },
  PeriodDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    //  textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    width: 600,
    //marginTop: 20,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      fontSize: 16,
      backgroundColor: "#fff",
    },
  },
  objectBoxStyle: {
    margin: 15,
    borderRadius: "8px",
    border: "1px solid lightGray",
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  backStyle: {
    cursor: "pointer",
    borderRadius: "4px",
    height: 35,
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  },
  iconStyle: {
    marginLeft: 12,
    height: 18,
    padding: 10,
    display: "flex",
    alignItems: "center",
    border: "1px solid lightGray",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#EEEEEE",
    },
  },
  dragIconBoxStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 5,
    paddingRight: 2,
    marginTop: 5,
    marginLeft: 5,
    marginRight: 5,
    marginBottom: 5,
    borderRadius: 4,
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  templateNameTextStyle: {
    //minWidth: 200,
    cursor: "pointer",
    fontWeight: 500,
    borderRadius: "8px",
    height: 30,
    fontSize: 24,
    display: "flex",
    padding: 5,
    paddingRight: 10,
    alignItems: "center",
    lineHeight: 1,
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  templateNameTextBoxStyle: {
    paddingTop: 12,
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    display: "flex",
    alignItems: "center",
    minWidth: 200,
  },
  templateNameFieldStyle: {
    width: 600,
    //marginTop: 20,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 4,
      height: 40,
      fontSize: 16,
      backgroundColor: "#fff",
    },
  },
}));
const CustomGridContainer = styled(Grid)(({ theme }) => ({
  ".MuiGrid-container": {
    flexWrap: "nowrap",
  },
}));
const StyledDivider = styled(Divider)(({ theme }) => ({
  flexGrow: 2,
}));

function EditTemplate() {
  const { termTemplateUuid } = useParams();
  const classes = useStyles();
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const cardRef = useRef(null);
  const dividerRef = useRef(null);
  const [loadContent, setLoadContent] = useState(false);
  const [pathname] = useState(window.location.pathname);
  const [templateName, setTemplateName] = useState("New Template");

  const [editedTemplateName, setEditedTemplateName] = useState("New Template");
  const [editingTemplateName, setEditingTemplateName] = useState(false);
  const [focusTemplateName, setFocusTemplateName] = useState(false);
  const [selectedPeriodName, setSelectedPeriodName] = useState("");
  const [selectedPeriodNoOfWeeks, setSelectedPeriodNoOfWeeks] = useState(0);
  const [periodDataList, setPeriodDataList] = useState([]);
  const [templateInfo, setTemplateInfo] = useState([]);
  const [addEditEventToPeridId, setAddEditEventToPeridId] = useState(null);
  const [lastDroppedComponent, setLastDroppedComponent] = useState(null);
  const [currentEditComponent, setCurrentEditComponent] = useState(null);
  const [openEditPeriodDialog, setOpenEditPeriodDialog] = useState(false);
  const [openEditEventDialog, setOpenEditEventDialog] = useState(false);
  const [termTemplateInfoInputDialog, setTermTemplateInfoInputDialog] = useState(false);
  const [alertMsg, setAlertMsg] = useState([]);

  const [termTemplateId, setTermTemplateId] = useState(0);

  const templateEvents = GetTemplateEvents();

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (
      periodDataList.length > 7 &&
      !addEditEventToPeridId &&
      dividerRef.current &&
      cardRef.current
    ) {
      // chnage Divider width according scrollWidth
      dividerRef.current.width = cardRef.current.scrollWidth;
      //scroll the Card component to the rightmost position after a new Period is added
      //cardRef.current.scrollLeft = cardRef.current.scrollWidth;
    }
    setAddEditEventToPeridId(null);
  }, [periodDataList]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else {
      window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        navigate(`${project_url}/signin/?next=${pathname}`);
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin/?next=${pathname}`);
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const [editAccess, setEditAccess] = useState(true);

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "General Settings",
              modulepageName: "Manage Term Templates"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
            
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      
      
      if(commonActions.find(a => a == "Edit")){
        setEditAccess(true);}
      else 
         setEditAccess(false)
      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  const [getTemplateDataQuery] = useManualQuery(GET_TERM_TEMPLATE_DATA_BY_ID);
  const [getTemplatePeriodsQuery] = useManualQuery(TEMPLATE_ALL_PERIODS_QUERY);
  const [templateAddPeriod] = useMutation(TEMPLATE_ADD_PERIOD_MUTATION);
  const [templateUpdatePeriod] = useMutation(TEMPLATE_UPDATE_PERIOD_MUTATION);
  const [templateDeletePeriod] = useMutation(TEMPLATE_DELETE_PERIOD_MUTATION);

  const [createEvent] = useMutation(ADD_TEMPLATE_EVENT_MUTATION, {
    awaitRefetchQueries: true,
  });
  const [editEvent] = useMutation(UPDATE_TEMPLATE_EVENT_MUTATION);
  const [deleteEvent] = useMutation(DELETE_TEMPLATE_EVENT_MUTATION);

  const [editTemplateName] = useMutation(EDIT_TERM_TEMPLATE_NAME_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [getTemplateIdQuery] = useManualQuery(GET_TERM_TEMPLATE_DATA_BY_UUID);

  useEffect(() => {
    (() => getTemplateData())();
  }, [termTemplateUuid]);

  const getTemplateData = async () => {
    const {
      loading: loadingTemplateData,
      error: errorTemplateData,
      data: dataTemplateData,
    } = await getTemplateIdQuery({
      variables: {
        termTemplateUuid: termTemplateUuid,
      },
    });
    if (dataTemplateData.getTermTemplateDataByUuid == null) {
      navigate(`${project_url}/tenant/dashboard`);
    } else if (
      !loadingTemplateData &&
      dataTemplateData &&
      dataTemplateData.getTermTemplateDataByUuid
    ) {
      setTermTemplateId(dataTemplateData.getTermTemplateDataByUuid.termTemplateId);
      setTemplateName(dataTemplateData.getTermTemplateDataByUuid.name);
      setEditedTemplateName(dataTemplateData.getTermTemplateDataByUuid.name);
      setTemplateInfo(dataTemplateData.getTermTemplateDataByUuid);
      // getTemplatePeriods();
    }
  };

  useEffect(() => {
    (() => getTemplatePeriods())();
  }, [termTemplateId]);

  const getTemplatePeriods = async () => {
    const {
      loading: loadingTemplatePeriods,
      error: errorTemplatePeriods,
      data: dataTemplatePeriods,
    } = await getTemplatePeriodsQuery({
      variables: {
        termTemplateId: parseInt(termTemplateId),
      },
    });
    if (
      !loadingTemplatePeriods &&
      dataTemplatePeriods &&
      dataTemplatePeriods.templateAllPeriodList
    ) {
      setPeriodDataList(dataTemplatePeriods.templateAllPeriodList);
    }
  };

  const handleDropPeriod = useCallback(
    component => setLastDroppedComponent(component),
    null
  );
  const handleDropEvent = useCallback((item, period) => {
    setAddEditEventToPeridId(period.termTemplatePeriodId);
    setSelectedPeriodName(period.name);
    setSelectedPeriodNoOfWeeks(period.noOfWeeks);
    setLastDroppedComponent(item);
  });

  const handleEditTemplateName = async () => {
    if (editedTemplateName.trim() != "") {
      setTemplateName(editedTemplateName);
      setEditingTemplateName(false);

      const { data, error } = await editTemplateName({
        variables: {
          name: editedTemplateName,
          termTemplateId: parseInt(termTemplateId),
        },
      });
      if (error) {
        console.log("Error", error, data);
        alert("Unfortunately an error occurred.");
      } else if (data && data.editTermTemplateName) {
        console.log("Success", data);
        getTemplateData();
      }
    } else alert("Please specify a name for template.");
  };

  const handleDoneAddEditPeriodObjectToTemplate = async (
    name,
    desc,
    noOfWeeks,
    inSprint
  ) => {
    let updatedList = [];
    
    let foundRow = findAnd.returnFound(periodDataList, {
      termTemplatePeriodId:
        currentEditComponent && currentEditComponent.termTemplatePeriodId,
    });
    
    if (foundRow) {
      updatedList = findAnd.changeProps(
        periodDataList,
        { termTemplatePeriodId: foundRow.termTemplatePeriodId },
        {
          name: name,
          desc: desc,
          noOfWeeks: noOfWeeks,
          inSprint: inSprint,
        }
      );
      
      // Update period's data in database
      let {
        loading: loadUpdateTemplatePeriod,
        error: errorUpdateTemplatePeriod,
        data: dataUpdateTemplatePeriod,
      } = await templateUpdatePeriod({
        variables: {
          termTemplatePeriodId: parseInt(foundRow.termTemplatePeriodId),
          name: name,
          desc: desc,
          noOfWeeks: noOfWeeks,
          inSprint: inSprint,
        },
      });
      if (
        !loadUpdateTemplatePeriod &&
        dataUpdateTemplatePeriod &&
        dataUpdateTemplatePeriod.updateTemplatePeriod &&
        dataUpdateTemplatePeriod.updateTemplatePeriod.termTemplatePeriod
      ) {
        setAlertMsg({
          title: "Success",
          msg: 'Period "' + name + '" is successfully updated.',
        });
      } else if (errorUpdateTemplatePeriod) {
        setAlertMsg({
          title: "Error",
          msg: "Unfortunately an error occurred.",
        });
      }
    } else {
      // Add new period to the Template and save into database
      let {
        loading: loadAddTemplatePeriod,
        error: errorAddTemplatePeriod,
        data: dataAddTemplatePeriod,
      } = await templateAddPeriod({
        variables: {
          termTemplateId: parseInt(termTemplateId),
          name: name,
          noOfWeeks: noOfWeeks,
          inSprint: inSprint,
          desc: desc,
        },
      });

      if (
        !loadAddTemplatePeriod &&
        dataAddTemplatePeriod &&
        dataAddTemplatePeriod.addTemplatePeriod &&
        dataAddTemplatePeriod.addTemplatePeriod.templatePeriod
      ) {
        setAlertMsg({
          title: "Success",
          msg: 'Period "' + name + '" is successfully saved.',
        });

        // Update periodDataList
        const newPeriod = {
          termTemplatePeriodId: parseInt(
            dataAddTemplatePeriod.addTemplatePeriod.templatePeriod.termTemplatePeriodId
          ),
          name,
          desc,
          noOfWeeks,
          inSprint,
          sequence: dataAddTemplatePeriod.addTemplatePeriod.templatePeriod.sequence,
          events: [],
        };
        updatedList = update(periodDataList, {
          $push: [newPeriod],
        });
      } else {
      }
    }
    setPeriodDataList(updatedList);
    setLastDroppedComponent(null);
    setOpenEditPeriodDialog(false);
    setCurrentEditComponent(null);
  };

  const handleDoneAddEditEventObjectToPeriod = async (
    name,
    eventType,
    noOfDaysAfter,
    desc,
    attendanceRequired
  ) => {
    let updatedList = [];
    let foundRow = findAnd.returnFound(periodDataList, {
      termTemplatePeriodId: addEditEventToPeridId,
    });
    if (!foundRow) {
      //Show alert msg of error from DB
      return;
    }
    //Currently the periodIndex and periodId are the same in static data.
    var periodIndex = periodDataList.findIndex(
      item => item.termTemplatePeriodId === foundRow.termTemplatePeriodId
    );

    // Getting eventTypeId by eventType name
    var foundEvent = templateEvents.find(item => item.name === eventType);

    if (currentEditComponent) {
      var eventIndex = foundRow.events.findIndex(
        item => item.termTemplateEventId === currentEditComponent.termTemplateEventId
      );
      if (eventIndex !== -1 && foundEvent) {
        updatedList = update(periodDataList, {
          [periodIndex]: {
            events: {
              [eventIndex]: {
                name: { $set: name },
                eventType: { $set: eventType },
                noOfDaysAfter: { $set: noOfDaysAfter },
                desc: { $set: desc },
                attendanceRequired: { $set: attendanceRequired },
              },
            },
          },
        });

        // Edit event's data in DB
        const {
          loading: loadEditEvent,
          error: errorEditEvent,
          data: dataEditEvent,
        } = await editEvent({
          variables: {
            termTemplateEventId: parseInt(currentEditComponent.termTemplateEventId),
            eventTypeId: parseInt(foundEvent.eventTypeId),
            name: name,
            desc: desc,
            noOfDaysAfter: noOfDaysAfter,
            attendanceRequired: attendanceRequired,
          },
        });

        if (
          !loadEditEvent &&
          dataEditEvent &&
          dataEditEvent.editEvent &&
          dataEditEvent.editEvent.event
        ) {
          setAlertMsg({
            title: "Success",
            msg: 'Event "' + name + '" is successfully updated.',
          });
        } else if (errorEditEvent) {
          setAlertMsg({
            title: "Error",
            msg: "Unfortunately an error occurred.",
          });
        }
      }
    } else {
      if (foundEvent) {
        let eventTypeId = parseInt(foundEvent.eventTypeId);
        if (foundRow.termTemplatePeriodId && eventTypeId) {
          // Add new event to the period and save in DB
          const {
            loading: loadCreateEvent,
            error: errorCreateEvent,
            data: dataCreateEvent,
          } = await createEvent({
            variables: {
              termTemplatePeriodId: parseInt(foundRow.termTemplatePeriodId),
              eventTypeId: eventTypeId,
              name: name,
              desc: desc,
              noOfDaysAfter: noOfDaysAfter,
              attendanceRequired: attendanceRequired,
            },
          });
          console.log("dataCreateEvent", dataCreateEvent);
          if (errorCreateEvent) {
            setAlertMsg({
              title: "Error",
              msg: "Unfortunately an error occurred.",
            });
          } else if (dataCreateEvent && dataCreateEvent.addTemplateEvent) {
            setAlertMsg({
              title: "Success",
              msg: 'Event "' + name + '" is successfully saved.',
            });

            const newEvent = {
              termTemplateEventId:
                dataCreateEvent.addTemplateEvent.templateEvent.termTemplateEventId,
              name,
              eventType,
              noOfDaysAfter: noOfDaysAfter,
              desc,
              attendanceRequired,
            };
            updatedList = update(periodDataList, {
              [periodIndex]: {
                events: {
                  $push: [newEvent],
                },
              },
            });
          }
        }
      }
    }
    setPeriodDataList(updatedList);
    setLastDroppedComponent(null);
    setAddEditEventToPeridId(null);
    setOpenEditEventDialog(false);
    setCurrentEditComponent(null);
  };

  const handleDeletePeriod = async () => {
    if (
      !currentEditComponent ||
      (currentEditComponent && currentEditComponent.periodid !== undefined)
    )
      return;
    var periodIndex = periodDataList.findIndex(
      item => item.termTemplatePeriodId === currentEditComponent.termTemplatePeriodId
    );
    if (periodIndex === -1) return;

    // Delete Period from Database
    let {
      loading: loadDeleteTemplatePeriod,
      error: errorDeleteTemplatePeriod,
      data: dataDeleteTemplatePeriod,
    } = await templateDeletePeriod({
      variables: {
        termTemplatePeriodId: parseInt(currentEditComponent.termTemplatePeriodId),
      },
    });
    if (errorDeleteTemplatePeriod) {
      setAlertMsg({
        title: "Error",
        msg: "Unfortunately an error occurred.",
      });
    } else if (!loadDeleteTemplatePeriod && dataDeleteTemplatePeriod) {
      setAlertMsg({
        title: "Success",
        msg: 'Period "' + currentEditComponent.name + '" is successfully removed.',
      });
      getTemplatePeriods();
    }
    // Update periodDataList
    const updatedList = update(periodDataList, {
      $splice: [[periodIndex, 1]],
    });
    setPeriodDataList(updatedList);
    setOpenEditPeriodDialog(false);
    setCurrentEditComponent(null);
  };
  const templateInfoFunc = async () => {
    setTermTemplateInfoInputDialog(true);
  };
  const handleDeleteEvent = async () => {
    let updatedList = [];
    let foundRow = findAnd.returnFound(periodDataList, {
      termTemplatePeriodId: addEditEventToPeridId,
    });
    if (!foundRow) {
      //Show alert msg of error from DB
      return;
    }
    var periodIndex = periodDataList.findIndex(
      item => item.termTemplatePeriodId === foundRow.termTemplatePeriodId
    );
    if (currentEditComponent) {
      var eventIndex = foundRow.events.findIndex(
        item => item.termTemplateEventId === currentEditComponent.termTemplateEventId
      );
      if (eventIndex !== -1) {
        updatedList = update(periodDataList, {
          [periodIndex]: {
            events: {
              $splice: [[eventIndex, 1]],
            },
          },
        });
      }
      // Delete event record from DB
      const {
        loading: loadingEventDelete,
        error: errorEventDelete,
        data: dataEventDelete,
      } = await deleteEvent({
        variables: {
          termTemplateEventId: parseInt(currentEditComponent.termTemplateEventId),
        },
      });

      if (errorEventDelete) {
        setAlertMsg({
          title: "Error",
          msg: "Unfortunately an error occurred.",
        });
      } else if (dataEventDelete && dataEventDelete.deleteTemplateEvent) {
        setAlertMsg({
          title: "Success",
          msg: 'Event "' + currentEditComponent.name + '" is successfully removed.',
        });
      }
    }
    setPeriodDataList(updatedList);
    setAddEditEventToPeridId(null);
    setOpenEditEventDialog(false);
    setCurrentEditComponent(null);
  };

  
  if (loadContent)
    if (editAccess)
    return (
      <div className={classes.cardContainer}>
        <Header
          breadcrumbs={[
            { label: "General Settings", link: null },
            {
              label: "Manage Term Templates",
              link: `${project_url}/tenant/settings/term_templates/`,
            },
            { label: templateName, link: null },
          ]}
        />
        {/* <TemplateHeader breadcrumbs={[{ label: templateName, link: null }]} /> */}
        <div className={classes.container}>
          <DndProvider backend={HTML5Backend}>
            <CustomGridContainer container spacing={1}>
              <Grid item style={{ width: 130 }}>
                <Card style={{ height: 540 }}>
                  <Box mb={1}>
                    <Box
                      mt={2}
                      mb={1}
                      ml={1}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                    >
                      <IconButton>
                        <img
                          src={backImg}
                          height={24}
                          onClick={() => navigate(`${project_url}/tenant/settings/term_templates`)}
                        />
                      </IconButton>
                      <Typography
                        variant="h5"
                        className={classes.backStyle}
                        onClick={() => navigate(`${project_url}/tenant/settings/term_templates`)}
                      >
                        Back
                      </Typography>
                    </Box>
                    <Divider />
                    <Typography variant="h2" style={{ paddingTop: 10 }}>
                      Period Objects
                    </Typography>
                    <Box pb={2}>
                      <Box className={classes.dragIconBoxStyle}>
                        <ComponentDragBox
                          component={PeriodComponents.PERIOD}
                          text="Period"
                          icon=""
                        />
                      </Box>
                    </Box>
                    <Divider />
                    <Typography variant="h2" style={{ paddingTop: 10 }}>
                      Event Objects
                    </Typography>
                    <Box
                      style={{
                        maxHeight: 350,
                        overflowY: "auto",
                        marginBottom: 10,
                        textAlign: 'left',
                      }}
                    >
                      {templateEvents.map(eventType => (
                        <Box className={classes.dragIconBoxStyle}>
                          <ComponentDragBox
                            component={eventType.name}
                            text={eventType.name}
                            icon=""
                          />
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Card>
              </Grid>
              <Grid item style={{ width: 1270 }}>
                <Card
                  ref={cardRef}
                  style={{
                    minHeight: 520,
                    paddingBottom: 20,
                    maxWidth: 1270,
                    overflowX: "auto",
                  }}
                >
                  <Box
                    mb={1.5}
                    ml={3}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {!editingTemplateName ? (
                      <Box className={classes.templateNameTextBoxStyle}>
                        <Typography
                          variant="h1"
                          className={classes.templateNameTextStyle}
                          onClick={() => {
                            setEditingTemplateName(true);
                            setFocusTemplateName(true);
                          }}
                        >
                          {templateName}
                        </Typography>
                        <IconButton>
                          <EditOutlinedIcon
                            onClick={() => {
                              setEditingTemplateName(true);
                              setFocusTemplateName(true);
                            }}
                          />
                        </IconButton>
                      </Box>
                    ) : (
                      <Box
                        style={{
                          paddingTop: 12,
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "start",
                          width: 400,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <TextField
                          id="outlined-multiline-static"
                          variant="outlined"
                          value={editedTemplateName}
                          inputRef={input => {
                            if (focusTemplateName && input != null) {
                              input.focus();
                            }
                          }}
                          className={classes.templateNameFieldStyle}
                          onChange={e => {
                            setEditedTemplateName(e.target.value);
                          }}
                          onKeyDown={e => {
                            e.key === "Enter" && handleEditTemplateName();
                          }}
                        />

                        <Box
                          className={classes.iconStyle}
                          onClick={handleEditTemplateName}
                        >
                          <CheckIcon sx={{ color: "gray", cursor: "pointer" }} />
                        </Box>

                        <Box
                          className={classes.iconStyle}
                          style={{ marginLeft: 7 }}
                          onClick={() => {
                            setEditingTemplateName(false);
                            setEditedTemplateName(templateName);
                          }}
                        >
                          <CloseIcon sx={{ color: "gray", cursor: "pointer" }} />
                        </Box>
                      </Box>
                    )}
                    <Box
                      style={{
                        width: 200,
                        display: "flex",
                        paddingTop: 10,
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        size="small"
                        className={classes.buttonStyle}
                        onClick={() => templateInfoFunc()}
                      >
                        Template Info
                      </Button>
                    </Box>
                  </Box>
                  <Divider ref={dividerRef} />
                  <Box mt={2} ml={2} mr={2}>
                    <Grid container>
                      {periodDataList &&
                        periodDataList.map(pd => (
                          <Grid
                            item
                            style={{
                              marginRight: 8,
                              width: 147,
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Box
                              style={{
                                border: "1px solid grey",
                                borderRadius: "8px",
                                height: "70px",
                                textAlign: "center",
                                backgroundColor: pd.inSprint ? "#E2F2FF" : "#FFFF80",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setCurrentEditComponent(pd);
                                setOpenEditPeriodDialog(true);
                              }}
                            >
                              <StyledTooltip title={pd.name}>
                                <Typography
                                  variant="h6"
                                  style={{
                                    fontWeight: 600,
                                    paddingLeft: 3,
                                    paddingRight: 5,
                                    paddingTop: 10,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "150px",
                                  }}
                                >
                                  {pd.name}
                                </Typography>
                              </StyledTooltip>
                              {pd.noOfWeeks === 1 ? (
                                <>
                                  <Typography variant="h6" style={{ paddingTop: 8 }}>
                                    {pd.noOfWeeks} week
                                  </Typography>
                                </>
                              ) : (
                                <>
                                  <Typography variant="h6" style={{ paddingTop: 8 }}>
                                    {pd.noOfWeeks} weeks
                                  </Typography>
                                </>
                              )}
                            </Box>
                            <Box pt={2}>
                              {pd.events &&
                                pd.events.map(ev => (
                                  <Grid
                                    item
                                    style={{
                                      width: 147,
                                      paddingTop: 7,
                                      marginRight: 8,
                                    }}
                                  >
                                    <Box
                                      style={{
                                        border: "1px solid grey",
                                        borderRadius: "8px",
                                        height: "70px",
                                        textAlign: "center",
                                        backgroundColor: "#B7FFB7",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        setCurrentEditComponent(ev);
                                        setSelectedPeriodName(pd.name);
                                        setSelectedPeriodNoOfWeeks(pd.noOfWeeks);
                                        setAddEditEventToPeridId(pd.termTemplatePeriodId);
                                        setOpenEditEventDialog(true);
                                      }}
                                    >
                                      <StyledTooltip title={ev.name}>
                                        <Typography
                                          variant="h6"
                                          style={{
                                            fontWeight: 600,
                                            paddingLeft: 3,
                                            paddingRight: 5,
                                            paddingTop: 8,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            maxWidth: "150px",
                                          }}
                                        >
                                          {ev.name}
                                        </Typography>
                                      </StyledTooltip>
                                      <Typography variant="h6" style={{ paddingTop: 4 }}>
                                        {ev.eventType}
                                      </Typography>
                                      {ev.noOfDaysAfter === 1 ? (
                                        <>
                                          <Typography
                                            variant="h6"
                                            style={{ paddingTop: 4 }}
                                          >
                                            1st day of period
                                          </Typography>
                                        </>
                                      ) : (
                                        <>
                                          {ev.noOfDaysAfter === 2 ? (
                                            <>
                                              <Typography
                                                variant="h6"
                                                style={{ paddingTop: 4 }}
                                              >
                                                2nd day of period
                                              </Typography>
                                            </>
                                          ) : (
                                            <>
                                              {ev.noOfDaysAfter === 3 ? (
                                                <>
                                                  <Typography
                                                    variant="h6"
                                                    style={{ paddingTop: 4 }}
                                                  >
                                                    3rd day of period
                                                  </Typography>
                                                </>
                                              ) : (
                                                <>
                                                  <Typography
                                                    variant="h6"
                                                    style={{ paddingTop: 4 }}
                                                  >
                                                    {ev.noOfDaysAfter}th day of period
                                                  </Typography>
                                                </>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </Box>
                                  </Grid>
                                ))}
                              <Grid
                                item
                                style={{
                                  width: 147,
                                  paddingTop: 7,
                                  marginRight: 8,
                                }}
                              >
                                <EventDropBox
                                  lastDroppedComponent={lastDroppedComponent}
                                  periodName={selectedPeriodName}
                                  noOfWeeks={selectedPeriodNoOfWeeks}
                                  onDrop={item => handleDropEvent(item, pd)}
                                  passObjOptions={(
                                    name,
                                    eventType,
                                    noOfDaysAfter,
                                    desc,
                                    attendanceRequired
                                  ) =>
                                    handleDoneAddEditEventObjectToPeriod(
                                      name,
                                      eventType,
                                      noOfDaysAfter,
                                      desc,
                                      attendanceRequired
                                    )
                                  }
                                  closeAddDialog={() => {
                                    setLastDroppedComponent(null);
                                    setAddEditEventToPeridId(null);
                                  }}
                                />
                              </Grid>
                            </Box>
                          </Grid>
                        ))}
                      <Grid item style={{ width: 147 }}>
                        <PeriodDropBox
                          lastDroppedComponent={lastDroppedComponent}
                          onDrop={handleDropPeriod}
                          passObjOptions={(name, desc, noOfWeeks, inSprint) =>
                            handleDoneAddEditPeriodObjectToTemplate(
                              name,
                              desc,
                              noOfWeeks,
                              inSprint
                            )
                          }
                          closeAddDialog={() => setLastDroppedComponent(null)}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Card>
              </Grid>

              {termTemplateInfoInputDialog && (
                <TemplateInfoInputDialog
                  termTemplateInfo={templateInfo}
                  closeDialog={value => {
                    getTemplateData();
                    setTermTemplateInfoInputDialog(false);
                  }}
                />
              )}
              {openEditPeriodDialog && (
                <EditPeriodDialog
                  closeDialog={() => {
                    setOpenEditPeriodDialog(false);
                    setCurrentEditComponent(null);
                  }}
                  handleDeletePeriod={handleDeletePeriod}
                  handleDone={(name, desc, noOfWeeks, inSprint) =>
                    handleDoneAddEditPeriodObjectToTemplate(
                      name,
                      desc,
                      noOfWeeks,
                      inSprint
                    )
                  }
                  periodName={currentEditComponent.name}
                  desc={currentEditComponent.desc}
                  noOfWeeks={currentEditComponent.noOfWeeks}
                  inSprint={currentEditComponent.inSprint}
                />
              )}
              {openEditEventDialog && (
                <EditEventDialog
                  closeDialog={() => {
                    setOpenEditEventDialog(false);
                    setCurrentEditComponent(null);
                  }}
                  handleDeleteEvent={handleDeleteEvent}
                  templateEvents={templateEvents}
                  handleDone={(
                    name,
                    eventType,
                    noOfDaysAfter,
                    desc,
                    attendanceRequired
                  ) =>
                    handleDoneAddEditEventObjectToPeriod(
                      name,
                      eventType,
                      noOfDaysAfter,
                      desc,
                      attendanceRequired
                    )
                  }
                  eventName={currentEditComponent.name}
                  desc={currentEditComponent.desc}
                  attendanceRequired={currentEditComponent.attendanceRequired}
                  eventType={currentEditComponent.eventType}
                  noOfDaysAfter={currentEditComponent.noOfDaysAfter}
                  periodName={selectedPeriodName}
                  noOfWeeks={selectedPeriodNoOfWeeks}
                />
              )}
            </CustomGridContainer>
          </DndProvider>
          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
              }}
            />
          )}
        </div>
      </div>
    );
  
  else
    return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default EditTemplate;
